import styled from "styled-components";

export const UnstyledButton = styled.button`
    padding: 0;
    border: none;
    line-height: 0;
    background-color: transparent;
    cursor: pointer;
`;
